exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".member-details img {\n  width: 36px;\n}\n.member-details .ant-row {\n  margin-bottom: 12px;\n  border-bottom: 1px solid #e5e9ec;\n}\n.member-details .ant-row p {\n  font-weight: lighter;\n}", ""]);

// exports
